import * as Turbo from "@hotwired/turbo"
import { nextFrame } from "../helpers"

// Using Turbo on an opt-in basis: <turbo-frame>s and elements with `data-turbo=true`
// https://turbo.hotwired.dev/reference/drive#turbo.session.drive
Turbo.session.drive = false

// Disable link prefetching
// https://turbo.hotwired.dev/handbook/drive#prefetching-links-on-hover
Turbo.session.linkPrefetchObserver.stop()

// Add autofocus support to <turbo-frame>s
addEventListener("turbo:frame-load", autofocus, { capture: true })

async function autofocus(event) {
  await nextFrame()
  const elements = event.target.querySelectorAll("[autofocus]:not(:disabled)")
  const element = [...elements].find((e) => e.checkVisibility())
  if (element) element.focus({ preventScroll: true })
}
